import React, { useState, useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useQuery, useMutation } from '@apollo/react-hooks'
import Grid from '@material-ui/core/Grid';
import MaterialTable from 'material-table';
import { withRouter } from "react-router-dom";
import DEPARTMENTWISEPROCESS from './DeptWiseProcessQuery';
import { ADD_DEPTWISEPROCESS, UPDATE_DEPTWISEPROCESS, DELETE_DEPTWISEPROCESS } from './DeptWiseProcessMutation';
import DEPTWISEPROCESS_SUBSCRIBE from './DeptWiseProcessSubscription';
import { DepartmentSelectComponent, DepartmentAllData } from '../../../components/DropdownSelect/SelectComponents/DepartmnetSelectComponent';
import { ProcessSelectComponent, ProcessAllData } from '../../../components/DropdownSelect/SelectComponents/ProcesSelectComponent';
import { packetTypeForDepartmentIssueReturn } from '../../../components/Constant';
import _ from 'lodash'
import { toast } from 'react-toastify';
import { FormatError } from '../../../components/Comman/FormatError'
import { CustomFilterComponent } from '../../../components/CustomFilterComponent/index'
const useStyles = makeStyles((theme) => ({
  root: { flexGrow: 1, },
  noMargin: { margin: 0 }
}));


const columns = [
  {
    title: 'From Department*', field: 'fromDept',
    render: (rowData) => rowData?.fromDept?.deptName,
    editComponent: props => {
      let valueDefault = props?.rowData?.fromDept?.id || props?.rowData?.fromDept || null
      return <DepartmentSelectComponent field="fromDept" valueDefault={valueDefault} propsData={props} />
    },
  },
  {
    title: 'To Department*', field: 'toDept', render: (rowData) => rowData?.toDept?.deptName,
    editComponent: props => {
      let valueDefault = props?.rowData?.toDept?.id || props?.rowData?.toDept || null
      return <DepartmentSelectComponent field="toDept" valueDefault={valueDefault} propsData={props} />
    },

  },
  {
    title: 'Process*', field: 'process', render: (rowData) => rowData?.process?.procName || "NO ANY PROCESS",
    editComponent: props => {
      let valueDefault = props?.rowData?.process?.id || 0
      return <ProcessSelectComponent field="process" valueDefault={valueDefault} propsData={props} />
    },
  },
  { title: 'Packet type*', field: 'pktType', lookup: packetTypeForDepartmentIssueReturn },
]

function DepartmetWiseProcess(props) {
  const classes = useStyles();
  const tableRef = useRef();

  const [pageSize, setPageSize] = useState(10)
  const [selectedRow, setSelectedRow] = useState(null);
  const [loader, setLoader] = useState(false);

  const permissions = props?.session?.me?.role?.permissions;
  const role = props?.session?.me?.role?.role;
  const path = props?.location?.pathname;
  let permission = _.find(permissions, function (o) { return o.name === path; })

  const { fetchMore, subscribeToMore } = useQuery(DEPARTMENTWISEPROCESS, {
    variables: { page: 1, limit: 10, filter: JSON.stringify({}), sort: { key: 'createdAt', type: -1 } },
    fetchPolicy: 'cache-and-network'
  })

  columns.map(col => {
    if (col.field === 'fromDept')
      col.filterComponent = (props) => {
        return <CustomFilterComponent propsData={props} defaultProps={{ options: DepartmentAllData(), getOptionLabel: (option) => option.deptName, multiple: true }} />
      }
    if (col.field === 'toDept')
      col.filterComponent = (props) => {
        return <CustomFilterComponent propsData={props} defaultProps={{ options: DepartmentAllData(), getOptionLabel: (option) => option.deptName, multiple: true }} />
      }
    if (col.field === 'process')
      col.filterComponent = (props) => {
        return <CustomFilterComponent propsData={props} defaultProps={{ options: ProcessAllData(), getOptionLabel: (option) => option.procName, multiple: true }} />
      }
    return null
  })

  const [AddDeptWiseProcessMutation] = useMutation(ADD_DEPTWISEPROCESS)
  const [updateDeptWiseProcessMutation] = useMutation(UPDATE_DEPTWISEPROCESS)
  const [deleteDeptWiseProcessMutation] = useMutation(DELETE_DEPTWISEPROCESS)

  useEffect(() => {
    if (subscribeToMore) {
      const unsubscribe = subscribeToMore({
        document: DEPTWISEPROCESS_SUBSCRIBE,
        updateQuery: (previousResult, { subscriptionData }) => {
          if (!subscriptionData.data) {
            return previousResult;
          }
          tableRef.current && tableRef.current.onQueryChange()
          return previousResult;
        },
      });
      return () => unsubscribe();
    }
  }, [subscribeToMore]);

  const AddDeptWiseProcess = (newData) => {
    return new Promise((resolve, reject) => {
      setLoader(true)
      if (newData.fromDept && newData.toDept && newData.process && newData.pktType) {
        let log = {
          action: 'INSERT',
          actionOn: 'DeptWiseProcess',
          actionName: 'addNewDeptWiseProcess',
          oldValue: "",
          message: `${newData?.fromDept || ''}-${newData?.toDept || ''} deptWiseProcess was created.`
        }
        AddDeptWiseProcessMutation({ variables: { input: newData, log } }).then((data) => {
          toast.success('department wise process created successfully.');
          setLoader(false)
          resolve()
        }).catch((e) => {
          reject()
          setLoader(false)
          toast.error(FormatError(e))
        })
      } else {
        setLoader(false)
        toast.warn('please, fill all required(*) fields.')
        reject()
      }
    })
  }

  const UpdateDeptWiseProcess = (newData, oldData) => {
    delete newData.createdBy
    delete newData.updatedBy
    delete newData.updatedAt
    delete newData.__typename
    delete newData.createdAt

    newData.fromDept = newData?.fromDept?.id || newData?.fromDept || null
    newData.toDept = newData?.toDept?.id || newData?.toDept || null
    newData.process = newData?.process?.id || newData?.process || null
    return new Promise((resolve, reject) => {
      setLoader(true)
      if (newData.fromDept && newData.toDept && newData.process && newData.pktType) {
        let log = {
          action: 'UPDATE',
          actionOn: 'DeptWiseProcess',
          actionName: 'updateDeptWiseProcess',
          oldValue: JSON.stringify(oldData),
          message: `${oldData?.fromDept?.deptName || ''}-${oldData?.toDept?.deptName || ''} deptWiseProcess was updated.`
        }
        updateDeptWiseProcessMutation({ variables: { input: newData, log } }).then((data) => {
          setLoader(false)
          toast.success('department wise process updated successfully.');
          resolve()
        }).catch((e) => {
          setLoader(false)
          reject()
          toast.error(FormatError(e))
        })
      } else {
        setLoader(false)
        toast.warn('please, fill all required(*) fields.')
        reject()
      }
    })
  }
  const DeleteDeptWiseProcess = (oldData) => {
    return new Promise((resolve, reject) => {
      setLoader(true)
      let log = {
        action: 'DELETE',
        actionOn: 'DeptWiseProcess',
        actionName: 'deleteDeptWiseProcess',
        oldValue: JSON.stringify(oldData),
        message: `${oldData?.fromDept?.deptName || ''}-${oldData?.toDept?.deptName || ''}  deptWiseProcess was deleted.`
      }
      deleteDeptWiseProcessMutation({ variables: { id: oldData.id, log } }).then((data) => {
        toast.success('department wise process deleted successfully.');
        setLoader(false)
        resolve()
      }).catch((e) => {
        reject()
        setLoader(false)
        toast.error(FormatError(e))
      })
    })
  }
  const getDeptWiseProcessData = (query) => {
    setLoader(true)
    return new Promise(async (resolve, reject) => {
      let filter = {}, sort = { key: 'createdAt', type: -1 }
      query && query.filters.forEach(item => {
        if (item.value.length === 0) {
          delete filter[`${item.column.field}`]
          filter = { ...filter }
        } else
          filter = { ...filter, [item.column.field]: item.value }
      });

      if (query && query.orderBy && query.orderDirection !== "") {
        sort = { key: query.orderBy.field, type: query.orderDirection === 'asc' ? 1 : -1 }
      }
      setPageSize(query.pageSize)
      try {
        let result = await fetchMore({
          variables: { page: query.page + 1, limit: query.pageSize, filter: JSON.stringify(filter), sort: sort },
          fetchPolicy: 'network-only',
          updateQuery: (prev, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prev;
            return fetchMoreResult;
          }
        })
        setLoader(false)
        resolve({
          data: result?.data?.getDeptWiseProcess?.data || [],
          page: query.page,
          totalCount: result?.data?.getDeptWiseProcess?.count || 0,
        })
      } catch (error) {
        console.log(FormatError(error))
        setLoader(false)
      }
    })
  }


  const addButton = (val) => {
    if (val || (role === 'admin'))
      return { onRowAdd: (newData) => AddDeptWiseProcess(newData) }
    else
      return {}
  }
  useEffect(() => {
    document.getElementsByClassName("parentTable")[0].firstElementChild.firstElementChild.firstChild.remove()
  }, [])
  return (<>

    <div className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <div className="parentTable">
            <MaterialTable
              title="Department Wise Process"
              columns={columns}
              tableRef={tableRef}
              isLoading={loader}
              data={query => getDeptWiseProcessData(query)}
              icons={{ Add: props => { return (<div> <i className="fa fa-plus-square" ></i> Department Wise Process </div>) } }}
              options={{
                emptyRowsWhenPaging: false,
                padding: 'dense',
                debounceInterval: 300,
                pageSize: pageSize,
                showTitle: false,
                pageSizeOptions: [5, 10, 15, 20, 25, 50],
                addRowPosition: 'first',
                filtering: true,
                sorting: true,
                search: false,
                filterCellStyle: { padding: '5px', },
                maxBodyHeight: window.innerHeight - 215,
                rowStyle: rowData => ({
                  backgroundColor: (selectedRow === rowData.tableData.id) ? 'rgb(212, 218, 255)' : '#f5f5f5'
                }),
                headerStyle: { backgroundColor: 'whitesmoke' }
              }}
              onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
              editable={{
                isEditHidden: (rowData) => (role === 'admin') ? false : !permission.isUpdate,
                isDeleteHidden: (rowData) => (role === 'admin') ? false : !permission.isDelete,
                ...addButton(permission?.isInsert),
                onRowUpdate: (newData, oldData) => UpdateDeptWiseProcess(newData, oldData),
                onRowDelete: (oldData) => DeleteDeptWiseProcess(oldData)
              }}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  </>
  );
}
export default withRouter(DepartmetWiseProcess)